import ErbilMap from './ErbilMap';
import MapComponent from './MapComponent';
import { FaWhatsapp, FaPhoneAlt, FaEnvelope, FaRegCheckCircle, FaMapMarkerAlt } from 'react-icons/fa';
const locations = [
    { name: 'Point A', latitude: 51.505, longitude: -0.09 },
    { name: 'Point B', latitude: 51.515, longitude: -0.1 },
];
const Erbil = () =>{
    return(
        <section id="map" className=" myMap map features">
                <h2 className="features-heading"> <span>:</span>تتوفر عدساتنا في المتاجر التالية </h2>
                <div className="feature-cards">
                  {[
                    { title: 'عوينات علي ', desc: 'اربيل - شارع الاطباء -  مقابل صيدلية بيار ', side: 'left'},
            { title: 'عوينات سيد احمد ', desc: ' اربيل - شارع 40 - بجانب مجمع طهران الطبي', side: 'right'},

            { title: 'مجمع ملائكة الرحمة', desc: 'اربيل - شارع 40 - بجانب مجمع طهران الطبي ', side: 'left' }

                  ].map((feature, index) => (
                    <div key={index} className={`dark-cards feature-card ${feature.side}`} >
                      <h4><FaMapMarkerAlt className="check-icon" size={20} />
        {feature.title}             
        </h4>
                      <p>{feature.desc}</p>
                    </div>
                  ))}
        
        </div>
        
                <ErbilMap locations={locations} />
        </section>
    )
}

export default Erbil


